import { format, parseISO, isValid } from "date-fns";
import { DatesFormat } from "shared-types";

export const formatDateToDayMonthYear = (dateString: string): string => {
  const date = parseISO(dateString);

  if (isValid(date)) {
    return format(parseISO(dateString), DatesFormat.dayMonthYearFormat);
  }

  return "";
};
